import { LucideIcon } from "lucide-react";
import { ReactNode } from "react";
interface CenteredWarningBoxProps {
  icon: LucideIcon;
  title: string;
  children: ReactNode;
  variant?: "default" | "destructive" | "warning";
}
const CenteredWarningBox = ({
  icon: Icon,
  title,
  children,
  variant = "destructive"
}: CenteredWarningBoxProps) => {
  const variantStyles = {
    default: "bg-accent/10 border-accent/30",
    destructive: "bg-destructive/10 border-destructive/30",
    warning: "bg-yellow-600/10 border-yellow-600/30"
  };
  const iconColor = {
    default: "text-accent",
    destructive: "text-destructive",
    warning: "text-yellow-600"
  };
  return <div className={`${variantStyles[variant]} border-2 rounded-lg p-4 sm:p-6 lg:p-8`}>
      <div className="flex flex-col items-center text-center">
        <Icon className={`w-10 h-10 sm:w-12 sm:h-12 ${iconColor[variant]} mb-4 sm:mb-6`} />
        
        <div className="w-full max-w-3xl">
          <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-foreground mb-3 sm:mb-4">
            {title}
          </h3>
          <div className="text-sm sm:text-base text-foreground/80 space-y-3 rounded-none">
            {children}
          </div>
        </div>
      </div>
    </div>;
};
export default CenteredWarningBox;